import { NgModule } from '@angular/core'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FlexLayoutModule } from '@angular/flex-layout';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { PipeModule } from '../../pipe';



@NgModule({
	imports: [
		CommonModule,
	],
	exports: [
		BrowserModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		FormsModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		PipeModule
	],
	providers: [
	]
})
export class UIToolsModule { }
